import React from "react";

type Order = {
    order?: RetrieveOrder;
}

type RetrieveOrder = {
    orderId: string;
    description: string;
    customer: CustomerInfo;
    device: DeviceInfo;
    statusHistory: OrderStatusAssociation[];
    workTypes: WorkTypeAssociation[];
    payments: PaymentInfo[];
    replacements: ReplacementAssociation[]
}

type CustomerInfo = {
    customerId: string;
    name: string;
    surname: string;
    phonePrefix: string;
    phoneNumber: string;
    email?: string;
}

type PaymentInfo = {
    paymentId: string;
    amount: number;
    paymentType: string;
    creationTimestamp: string;
}

type DeviceInfo = {
    deviceId: string;
    model: string;
}

type OrderStatusAssociation = {
    associationId: string;
    status: string;
    creationTimestamp: string;
}

type WorkTypeAssociation = {
    associationId: string;
    workType: string;
}

type ReplacementAssociation = {
    associationId: string;
    description: string;
    amount: number;
}

const PrintReceiptButton: React.FC<Order> = ({order}) => {
    const trackUrl = `https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${window.location.origin}/track/${order?.orderId}`
    const labUrl = `https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${window.location.origin}/order/${order?.orderId}`
    const handlePrint = async () => {
        const printWindow = window.open("", "_blank");

        if (!printWindow) {
            console.error("Unable to open print window");
            return;
        }

        printWindow.document.open();

        printWindow.document.write(`<!DOCTYPE html>
<html lang="it">
<head>
    <meta charset="UTF-8"/>
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <title>Ricevuta Riparazione Smartphone</title>
    <style>
        body {
            margin: 0;
            padding: 0;
            background: #efefef;
            font-family: 'Courier New', monospace;
        }

        .receipt {
            width: 80mm;
            margin: 10px auto;
            background: #fff;
            color: #000;
            padding: 10px;
            box-sizing: border-box;
            font-size: 12px;
            line-height: 1.4;
        }

        .section {
            padding-bottom: 12px;
            margin-bottom: 12px;
            border-bottom: 2px dashed #000;
        }

        .center {
            text-align: center;
        }

        .bold {
            font-weight: bold;
        }

        .title {
            font-size: 15px;
            margin-bottom: 4px;
        }

        .divider {
            border-top: 1px dashed #000;
            margin: 8px 0;
        }

        .info-row {
            margin-bottom: 4px;
        }

        .label {
            font-weight: bold;
        }

        .qr {
            width: 100px;
            height: 100px;
            margin: 10px auto;
            border: 1px solid #000;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 11px;
            text-align: center;
        }

        ul {
            padding-left: 16px;
            margin: 6px 0;
        }

        li {
            margin-bottom: 4px;
        }

        .footer {
            margin-top: 10px;
            text-align: center;
            font-size: 11px;
        }

        @media print {
            body {
                background: white;
                margin: 0;
            }

            .receipt {
                width: 80mm;
                margin: 0;
                padding: 8px;
            }
        }
    </style>
</head>
<body>
<div class="receipt">

    <!-- COPIA CLIENTE -->
    <div class="section">
        <div class="center bold title">
            COPIA CLIENTE
        </div>

        <div class="center bold">
            Casablanca Riparazioni
        </div>

        <div class="center">
            Via Cataldo Nitti,87 - Taranto<br>
            Tel: +39 351 1807814
        </div>

        <div class="divider"></div>

        <div class="info-row">
            <span class="label">Codice Ordine:</span><br>
            ${order?.orderId}
        </div>

        <div class="info-row">
            <span class="label">Cliente:</span>
            ${order?.customer.name + " " + order?.customer.surname}
        </div>

        <div class="info-row">
            <span class="label">Dispositivo:</span>
            ${order?.device.model}
        </div>

        <div class="info-row">
            <span class="label">Importo Totale:</span>
            € ${order?.replacements
            .reduce((total, replacement) => total + replacement.amount, 0)
            .toFixed(2)}
        </div>

        <div class="divider"></div>

        <div class="center bold">
            Traccia lo stato della riparazione
        </div>

        <div class="center">
            <img
                    src="${trackUrl}"
                    alt="QR Code Tracking"
                    width="100"
                    height="100"
            />
        </div>

        <div class="footer">
            Mostrare questa ricevuta al ritiro.
        </div>
    </div>

    <!-- COPIA TECNICO/VENDITORE -->
    <div class="section" style="border-bottom: none; margin-bottom: 0; padding-bottom: 0;">
        <div class="center bold title">
            COPIA LABORATORIO
        </div>

        <div class="center bold">
            Casablanca Riparazioni
        </div>

        <div class="divider"></div>

        <div class="info-row">
            <span class="label">Codice Ordine:</span><br>
            ${order?.orderId}
        </div>

        <div class="info-row">
            <span class="label">Cliente:</span>
            ${order?.customer.name + " " + order?.customer.surname}
        </div>

        <div class="info-row">
            <span class="label">Dispositivo:</span>
            ${order?.device.model}
        </div>

        <div class="info-row">
            <span class="label">Codice sblocco:</span>
            __________
        </div>

        <div class="divider"></div>

        <div class="bold">
            Lavorazioni da eseguire:
        </div>

        <ul>
            ${
            order?.workTypes
                ?.map(
                    (workType) =>
                        `<li>${workType.workType}</li>`
                )
                .join("") || "<li>Nessuna lavorazione</li>"
        }
        </ul>

        <div class="divider"></div>

        <div class="center bold">
            QR Tracking Tecnico
        </div>

        <div class="center">
            <img
                    src="${labUrl}"
                    alt="QR Code Tecnico"
                    width="100"
                    height="100"
            />
        </div>

        <div class="footer">
            Documento interno laboratorio
        </div>
    </div>

</div>
</body>
</html>
        `);

        printWindow.document.close();

        // Close window after print dialog closes
        printWindow.onafterprint = () => {
            printWindow.close();
        };
        printWindow.focus();

        // Let browser render content before opening print dialog
        setTimeout(() => {
            printWindow.print();
        }, 300);
    };

    return (
        <button
            onClick={handlePrint}
            className="flex items-center gap-2 bg-blue-900 text-white px-4 py-2 rounded-lg hover:bg-blue-800 transition">
            <svg
                className="w-5 h-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                {/* Printer body */}
                <path d="M6 9V4h12v5"/>
                <rect x="4" y="9" width="16" height="8" rx="2"/>

                {/* Paper */}
                <path d="M8 13h8"/>
                <path d="M8 17h8"/>

                {/* Bottom tray */}
                <path d="M6 17v3h12v-3"/>
            </svg>
            Stampa Ricevuta
        </button>
    );
};

export default PrintReceiptButton;